define(['text!./button.html'], (template) => {
    return [() => ({
        restrict: 'E',
        replace: true,
        template: template,
        transclude: true,
        scope: {
            onClick: '&'
        },
        link: (scope, element, attrs) => {
            scope.primary = 'primary' in attrs;
        }
    })];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/atomic_design/button/button.js